module.exports = __webpack_public_path__ + "static/media/8.515118b9.jpeg";